import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setCredentials, logOut } from '../features/authentication/authSlice';

// eslint-disable-next-line no-undef
// const env = process.env.REACT_APP_NODE_ENV;
// const currentConfig = appConfig[env];
import appConfig from '../app-config';

const baseUrl = appConfig.apiBaseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: baseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.accessToken;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  // If unauthorized try getting new token with the refresh token
  if (result?.error?.status === 401) {
    var refreshArgs = {
      url: 'Account/RefreshToken',
      method: 'POST',
      credentials: 'include'
    };

    // send refresh token to get new access token
    const refreshResult = await baseQuery(refreshArgs, api, extraOptions);

    if (refreshResult?.data) {

      // Store the new token
      api.dispatch(
        setCredentials({
          accessToken: refreshResult.data.accessToken
        })
      );
      // Retry original query with the new token
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  // eslint-disable-next-line no-unused-vars
  endpoints: (builder) => ({}),
  refetchOnMountOrArgChange:true
});

export const classicApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: 'https://localhost:443' }),
  // eslint-disable-next-line no-unused-vars
  endpoints: (builder) => ({})
});
